import { GetServerTime } from './GetServerTime';
import { CheckErrorsPreviousDay } from './CheckErrorsPreviousDay';
import { EntradaIncidencia } from './EntradaIncidencia';
import { checkAbsenceDay } from './CheckAbsenceDay';
import { doc, setDoc, collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase';
import moment from 'moment';

const sendHolidayNotification = async (user, time, motivo) => {
  try {
    await addDoc(collection(db, 'notifications'), {
      notificationDate: new Date(),
      holidayDate: moment(time).format('DD-MM-YYYY'),
      uid: user.uid,
      name: user.displayName,
      email: user.email,
      avatar: user.photoURL || null,
      departamento: user.departamento || null,
      iniciales: user.iniciales || null,
      observation: motivo || '',
      type: 'Festivo',
      status: 'Pendiente',
      processed: false,
      read: false,
    });
  } catch (error) {
    console.error('Error al registrar la notificación de festivo:', error);
  }
};

export const Entrada = async (props, estado, isFestivo, motivo) => {
  const records = props.userRecords;
  const user = props.userSession;

  //Obtenemos la fecha y hora del servidor
  var serverTime = await GetServerTime();
  const time = serverTime.formatted;

  //Comprueba si hay una ausencia aceptada para ese día
  const hasAbsence = await checkAbsenceDay(user.uid, moment(time).format('DD/MM/YYYY'));
  if (hasAbsence) {
    alert('No puedes fichar porque tienes una ausencia aprobada este día');
    return;
  }

  //Comprueba cuantos registros tenemos diarios
  var longRecord = 0;
  if (records[moment(time).format('DD-MM-YYYY')]) {
    var dailyRecords = records[moment(time).format('DD-MM-YYYY')];
    longRecord = Object.keys(dailyRecords).length;
  }

  if (longRecord === 0) {
    await CheckErrorsPreviousDay(props, time);
  }

  if (longRecord === 0 || records[moment(time).format('DD-MM-YYYY')][longRecord - 1].salida) {
    let estadoFichaje = isFestivo ? 'Festivo' : estado;
    let estadoSesion = isFestivo ? 'Presencial' : estado;

    //No permite fichajes antes de las 7 am y despues de las 20
    if (!(parseInt(moment(time).format('HH')) < 7 || parseInt(moment(time).format('HH')) > 20)) {
      //Comprueba si el registro anterior tiene una incidencia
      if (longRecord === 0 || !records[moment(time).format('DD-MM-YYYY')][longRecord - 1].tpIncidencia) {
        //Entrada normal
        const newRecord = {
          entrada: moment(time).format('HH:mm'),
          tpRegistro: estadoFichaje,
        };
        if (isFestivo) newRecord.status = 'Pendiente';
        if (motivo) newRecord.tpFestivo = motivo;

        // prettier-ignore
        await setDoc(doc(db, 'users', user.uid, 'registros', moment(time).format('MMMM-YYYY')),{
          [moment(time).format('DD-MM-YYYY')]: { [longRecord]: newRecord },
        },{ merge: true });
        // cambia el estado del usuario
        // prettier-ignore
        await setDoc(doc(db, 'users', user.uid),{
          estadoSesion: estadoSesion
        }, {merge:true})

        if (isFestivo && longRecord === 0) {
          await sendHolidayNotification(user, time, motivo);
        }
      } else {
        //Entrada con incidencia
        //alert('Entrada con incidencia');
        await EntradaIncidencia(props, estadoFichaje, longRecord - 1, time);
        // prettier-ignore
        await setDoc(doc(db, 'users', user.uid),{
          estadoSesion: estadoSesion
        }, {merge:true})
      }
    } else {
      // Si el fichaje es mayor de 8 muestra error
      if (!(parseInt(moment(time).format('HH')) >= 20)) {
        var resultado = window.confirm('No son todavía las 07:00 \n ¿Desea realizar el fichaje a las 07:00? ');
        if (resultado === true) {
          const newRecord = {
            entrada: '07:00',
            tpRegistro: estadoFichaje,
          };
          if (isFestivo) newRecord.status = 'Pendiente';
          if (motivo) newRecord.tpFestivo = motivo;

          // prettier-ignore
          await setDoc(doc(db, 'users', user.uid, 'registros', moment(time).format('MMMM-YYYY')),{
            [moment(time).format('DD-MM-YYYY')]: { [longRecord] : newRecord }
          },{ merge: true });
          // prettier-ignore
          await setDoc(doc(db, 'users', user.uid),{
            estadoSesion: estadoSesion
          }, {merge:true})

          if (isFestivo && longRecord === 0) {
            await sendHolidayNotification(user, time, motivo);
          }
        }
      } else {
        alert('No se puede fichar a partir de las 8 de la tarde.');
      }
    }
  } else {
    alert('No has registrado una salida');
  }
};
